import Vue from 'vue';
import Router from 'vue-router';

import Login from '@/components/Login';
import Dashboard from '@/components/Dashboard';
import Profile from '@/components/Profile';
import UserAccounts from "../components/UserAccounts";
import UserAccount from "../components/UserAccount";
import Buildings from "../components/Buildings";
import Building from "../components/Building";

Vue.use(Router);

export default new Router({
	routes: [
		{path: '/dashboard', name: 'dashboard', component: Dashboard, meta: {}},
		{path: '/login', name: 'login', component: Login, meta: {}},
		{path: '/profile', name: 'profile', component: Profile, meta: {}},
		{path: '/user-accounts', name: 'userAccounts', component: UserAccounts, meta: {}},
		{path: '/user-accounts/:id', name: 'userAccount', component: UserAccount, meta: {}},
		{path: '/buildings', name: 'buildings', component: Buildings, meta: {}},
		{path: '/buildings/:id', name: 'building', component: Building, meta: {}},
	]
});


